

function accordionHandler(e) {
    var i;
    for (i = 0; i < accordionParentElements.length; i++) {
        if (e.target.parentNode != accordionParentElements[i]) {
            accordionParentElements[i].classList.remove("__active");
        }
    }
    e.target.parentNode.classList.toggle("__active");
}


$(".accordion__title").click(function (e) {
    if (e) {
        e.preventDefault();
    }
    $clickedTitleParent = $(this).parent();

    if ($clickedTitleParent.hasClass("__active")) {
        $clickedTitleParent.removeClass("__active");
    } else {
        // allow product detail accordion to have multiple accordions open:
        if(!($(this).parent().parent().hasClass("product__accordion"))) {
            $(".accordion").removeClass("__active");
        }
        $clickedTitleParent.addClass("__active");
    }
});

function returnPriceWithOptionalExtrasAdded(basePrice) {
    var adjustedPrice = basePrice;
    var addingOptionalExtras = [];
    var optionalExtrasList, thisValue, i;
    if(document.getElementById('optionalExtras')) {
        optionalExtrasList = document.querySelectorAll('#optionalExtras .extra-option-selector');
        for (i = 0; i < optionalExtrasList.length; i++) {
            if (optionalExtrasList[i].querySelector('.cc-select__option[aria-selected="true"]')) {
                thisValue = optionalExtrasList[i].querySelector('.cc-select__option[aria-selected="true"]').getAttribute("data-value");
                if(thisValue != 'None') {
                    adjustedPrice += parseInt(thisValue.split('###')[2]);
                }
            }
        }
    } 
    if(document.getElementById('optionalExtrasTabbed')) {
        optionalExtrasList = document.querySelectorAll('#optionalExtrasTabbed .extra-item input');
        for (i = 0; i < optionalExtrasList.length; i++) {
            if (optionalExtrasList[i].checked) {
                adjustedPrice += parseInt(optionalExtrasList[i].getAttribute("data-price"));
            }
        }
    }
    return adjustedPrice;
}

function absoluteVariantChange(variant) {
    if(variant === null) {
        // find this dynamically:
        var $primarySelect = $('select[name="id"]');
        var variant = {
            'title': $primarySelect.find(":selected").text(),
            'id': $primarySelect.val()
        };
    }
    var additionalOptionsList, i, thisValue;
    var fakeVariantsToAdd = [];
    var fakeVariantsString = '';
    if(document.getElementById('productEnquiry')) {
        // look for additional variant options from the additional_variant_options metafield:
        additionalOptionsList = document.querySelectorAll('.fake-variant-options');
        if(additionalOptionsList.length>0) {
            for (i = 0; i < additionalOptionsList.length; i++) {
                thisValue = additionalOptionsList[i].querySelector('.cc-select__option[aria-selected="true"]').getAttribute("data-value");
                fakeVariantsToAdd.push(additionalOptionsList[i].getAttribute('data-label')+": "+thisValue);
            }
        }
        if(fakeVariantsToAdd.length > 0) {
            fakeVariantsString = '|||'+fakeVariantsToAdd.join(" - ");
        }
        document.getElementById('productEnquiry').href = document.getElementById('productEnquiry').getAttribute('data-root')+encodeURIComponent(variant.title + fakeVariantsString);
    }
    if(document.getElementById('addToQuote')) {
    document.getElementById('addToQuote').setAttribute('data-variant', variant.id);
    }
}

function roundDownToNearestFive(x) {
    return Math.floor( x / 5) * 5;
}

function absoluteApplyWeightRange(filterFormData) {
    if(document.getElementById('AbsWeightRangeMin')) {
        var weightMin = roundDownToNearestFive(parseInt(document.getElementById('AbsWeightRangeMin').value));
        var weightMax = roundDownToNearestFive(parseInt(document.getElementById('AbsWeightRangeMax').value));
        if(weightMin > 0) {
            if(weightMax > 0) {
                if(weightMax >= weightMin) {
                    var i;
                    // increment in 5s
                    for (var i=weightMin; i<=weightMax;i+=5) {
                        filterFormData.append("filter.p.m.absolute.crew_weight", i);
                    }
                }
            }
        }
    }      
    return filterFormData;
}

$( document ).ready(function() {

if($('.fourUpSlider').length>0) {
  $('.fourUpSlider').slick({
    centerMode: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
    arrows: true,
    prevArrow: theme.icons.slideshowPrevArrow,
    nextArrow: theme.icons.slideshowNextArrow,
    appendArrows: $('.slick-external-controls--fourUpSlider .slick-arrows'),
    appendDots: $('.slick-external-controls--fourUpSlider .slick-dots'),
    autoplaySpeed: 4500,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
}



if($('#visualFilters').length>0) {
  $('#visualFilters').slick({
    centerMode: false,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: true,
    prevArrow: theme.icons.slideshowPrevArrow,
    nextArrow: theme.icons.slideshowNextArrow,
    infinite: false,
    swipeToSlide: true,
    prevArrow: theme.icons.slideshowPrevArrow,
    nextArrow: theme.icons.slideshowNextArrow,
    responsive: [
          {
        breakpoint: 940,
        settings: {
            slidesToShow: 3.5
        }
      },
          {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  });
}


$( "body" ).on( "click", ".inventorySlideToggle", function(e) {
    if(e) {
        e.preventDefault();
    }
    if($(this).hasClass('active')) {
        $(this).text($(this).attr('data-more'));
    } else {
        $(this).text($(this).attr('data-less'));
    }
    $(this).toggleClass('active').parents('.product-block--inventory').find('.inventory--more-content').slideToggle('fast');
});

$("body").on( "click", ".inventorySlideToggleClose", function(e) {
    if(e) {
        e.preventDefault();
    }
    $(this).parents('.product-block--inventory').find('.inventory--more-content').slideUp('fast');
    $(this).parents('.product-block--inventory').find('.inventorySlideToggle').removeClass('active').text($(this).parents('.product-block--inventory').find('.inventorySlideToggle').attr('data-more'));
    
});




    checkPartsOrderValid = function(e) {
        if(e) {
            e.preventDefault();
        }
        document.getElementById('partsErrorContainer').innerHTML = '';
        var isValid = true;
        var validationList = document.querySelectorAll('.partsOrderValidation');
        if(validationList.length > 0) {
            for (var i = 0; i < validationList.length; i++) {
                if(validationList[i].value == '') {
                    isValid = false;
                    validationList[i].parentNode.classList.add("error");
                    validationList[i].onblur = checkInputBlur;
                    break;
                } else {
                    validationList[i].parentNode.classList.remove("error");
                }
            }
        }
        if(isValid) {
            document.querySelector('.parts-order-form-validate').submit();
        } else {
            // show error
            document.getElementById('partsErrorContainer').innerHTML = '<div class="errors">Please fill in all measurements - use ? if you\'re unsure</div>';
        }
    }

addOptionalExtrasToCart = function(variants, timestamp) {
    var formData = {items: []}
    for (let i = 0; i < variants.length; i++) {
        formData.items.push({
            'id': variants[i],
            'quantity': 1,
            'properties': {
                '_timestamp': timestamp,
                '_child': "true"
            }
        });
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            document.querySelector('.product__submit__add').classList.remove('is-loading');
            document.querySelector('.product__submit__add').classList.add('is-success');
            // update minicart:
            // Shopify.getCart();
            // open minicart:
            // document.querySelector(".navlink--cart").click();
            
            document.querySelector("#addtocart").click();
          
            // update the timestamp in case another item is added:
            document.getElementById('productTimeStamp').value = Date.now();

            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}


addOptionalExtras = function(e) {
    
    var addingOptionalExtras = [];
    var optionalExtrasList, i, thisValue;
    // boat products use the Optional Extra tabs:
    if(document.getElementById('optionalExtrasTabbed')) {
        optionalExtrasList = document.querySelectorAll('#optionalExtrasTabbed .extra-item input');
        for (i = 0; i < optionalExtrasList.length; i++) {
            if (optionalExtrasList[i].checked) {
                addingOptionalExtras.push(optionalExtrasList[i].getAttribute("data-variant"));
            }
        }
    } else {
        // other products build select dropdowns under the other variants:
        optionalExtrasList = document.querySelectorAll('#optionalExtras .extra-option-selector');
        for (i = 0; i < optionalExtrasList.length; i++) {
            if (optionalExtrasList[i].querySelector('.cc-select__option[aria-selected="true"]')) {
                thisValue = optionalExtrasList[i].querySelector('.cc-select__option[aria-selected="true"]').getAttribute("data-value");
                if(thisValue != 'None') {
                    addingOptionalExtras.push(thisValue.split('###')[1]);
                }
            }
        }
    }
    if(addingOptionalExtras.length > 0) {
        document.querySelector('.product__submit__add').classList.add('is-loading');
        addOptionalExtrasToCart(addingOptionalExtras, document.getElementById('productTimeStamp').value);
    } else {
        document.querySelector(".product__submit__add").click();
        // update the timestamp in case another item is added:
        document.getElementById('productTimeStamp').value = Date.now();
    }
    
}

if(document.getElementById('optionalExtrasAddBlocker')) {
    document.getElementById('optionalExtrasAddBlocker').onclick = addOptionalExtras;
}

function updatePriceWithSelectedOptionalExtras() {
    // find current price:
    var activePrice = parseInt($("[data-product-price] .theme-money").attr('data-price'));
    $("[data-product-price]").html('<span class="theme-money large-title" data-price="'+ activePrice +'">' + theme.Shopify.formatMoney(returnPriceWithOptionalExtrasAdded(activePrice), theme.moneyFormatWithCodeForProductsPreference) + '</span>');
    
}

if($('.fake-variant-options').length > 0) {
    // initialise on change for the custom drop downs:
    $('.fake-variant-options').click(function(e) {
        absoluteVariantChange(null);
     });   
}


if(document.getElementById('optionalExtras')) {
    // initialise on change for the custom drop downs:
    $('#optionalExtras .extra-option-selector .cc-select').click(function(e) {
        updatePriceWithSelectedOptionalExtras();
     });   
}

if(document.getElementById('optionalExtrasTabbed')) {
    // initialise on click for the optional extras in the tabs:
    $('#optionalExtrasTabbed .extra-item input').click(function(e) {
        updatePriceWithSelectedOptionalExtras();
    });
}


$( "body" ).on( "click", "a.btn-addToQuote", function(e) {
    if(e) {
        e.preventDefault();
    }
    var i;
    var quoteItems = [];
    var foundMatchingItem = false;
    var variantToAdd = e.target.getAttribute('data-variant');
    // determine any price increase from optional extras:
    var priceOverrideToAdd = returnPriceWithOptionalExtrasAdded(0);
    var extrasToAdd = [];


    // determine any extras
    if(document.getElementById('optionalExtrasTabbed')) {
        optionalExtrasList = document.querySelectorAll('#optionalExtrasTabbed .extra-item input');
        for (i = 0; i < optionalExtrasList.length; i++) {
            if (optionalExtrasList[i].checked) {
                extrasToAdd.push(optionalExtrasList[i].getAttribute("data-title"));
            }
        }
    } else {
        // other products build select dropdowns under the other variants:
        optionalExtrasList = document.querySelectorAll('#optionalExtras .extra-option-selector');
        for (i = 0; i < optionalExtrasList.length; i++) {
            if (optionalExtrasList[i].querySelector('.cc-select__option[aria-selected="true"]')) {
                thisValue = optionalExtrasList[i].querySelector('.cc-select__option[aria-selected="true"]').getAttribute("data-value");
                if(thisValue != 'None') {
                    extrasToAdd.push(thisValue.split('###')[0]);
                }
            }
        }
    }


    if (localStorage.getItem("quoteItems") !== null) {
        quoteItems = JSON.parse(localStorage.getItem("quoteItems"));

        // see if variant already exists:
        for (thisQuoteItem in quoteItems) {
            if(quoteItems[thisQuoteItem].variant == variantToAdd) {
                if(quoteItems[thisQuoteItem].priceincrease == priceOverrideToAdd) {
                    if(JSON.stringify(quoteItems[thisQuoteItem].extras) === JSON.stringify(extrasToAdd)) {
                        foundMatchingItem = true;
                        quoteItems[thisQuoteItem].quantity += 1;
                    }
                }
            }

        }
    }

    if(!foundMatchingItem) {
        quoteItems.push({'product':e.target.getAttribute('data-product'),'variant': variantToAdd,'quantity':1,'extras':extrasToAdd,'priceincrease':priceOverrideToAdd});
    }
    var numberOfItems = 0;
    for (thisQuoteItem in quoteItems) {
        numberOfItems += quoteItems[thisQuoteItem].quantity;
    }
    localStorage.setItem("quoteItems", JSON.stringify(quoteItems));
    theme.showQuickPopup("This item has been added to your quote", $(this));
    $('#quoteListCount').html(numberOfItems);
});

if (localStorage.getItem("quoteItems") !== null) {
    var quoteItems = JSON.parse(localStorage.getItem("quoteItems"));
    var numberOfItems = 0;
    for (thisQuoteItem in quoteItems) {
        numberOfItems += quoteItems[thisQuoteItem].quantity;
    }
    $('#quoteListCount').html(numberOfItems);
}


});

function updateFormSession() {
    const formData = new FormData(document.querySelector('.absolute-send-mail-form'));
    var formDataToStore = {};
    for (const pair of formData.entries()) {
        if(pair[0] != 'utf8') {
            if(pair[0] != 'form_type') {
                formDataToStore[(pair[0])] = pair[1];
            }
        }
    }
    sessionStorage.setItem('sendMailFormData', JSON.stringify(formDataToStore));
}

$(function() {
    if($('.absolute-send-mail-form').length > 0) {
        // save form changes in session storage so the save form submission script can access it after the form is submitted
        $('.absolute-send-mail-form input, .absolute-send-mail-form textarea, .absolute-send-mail-form select').on( "change keyup paste blur", function(e) {
            if(!($(this).hasClass('contact-form__submit'))) {
               updateFormSession(); 
            }
        });
    }
});